<template>

  <section class="forms">
    <div class="page-header">
      <h3 class="page-title">
      <span class="page-title-icon bg-gradient-primary text-white mr-2">
        <i class="mdi mdi-account"></i>
      </span> Account </h3>
      <nav aria-label="breadcrumb">
        <ul class="breadcrumb">
        </ul>
      </nav>
    </div>
    <div class="row">
      <div class="col-md-4 grid-margin stretch-card">
        <div class="card aligner-wrapper">
          <div class="card-body">
            <div class="absolute left top bottom h-100 v-strock-2 bg-success"></div>
            <p class="text-muted mb-2">Registered user</p>
            <div class="d-xl-flex align-items-center">
              <h1 class="font-weight-medium mb-2" v-if="user">{{ user.attributes.email | splitEmail }}</h1>
              <div class="dot-opacity-loader" v-show="loadingAcc">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div class="bg-success dot-indicator"></div>
              <p class="text-muted mb-0 ml-2" v-if="user">{{ user.attributes.email }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 grid-margin stretch-card">
        <div class="card aligner-wrapper">
          <div class="card-body">
            <div class="absolute left top bottom h-100 v-strock-2 bg-primary"></div>
            <p class="text-muted mb-2">Account Type</p>
            <div class="d-xl-flex align-items-center">
              <h1 class="font-weight-medium mb-2" v-if="usagePlan">{{ usagePlan }}</h1>
              <div class="dot-opacity-loader" v-show="loadingType">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div class="bg-primary dot-indicator"></div>
              
              <router-link to="/upgrade" v-if="usagePlan === 'FREEBIE'" class="text-muted"><p class="text-muted mb-0 ml-2">Upgrade to support tcup</p></router-link>
              <p v-if="usagePlan === 'BESTIE'" class="text-muted mb-0 ml-2">Thank you for your support</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 grid-margin stretch-card" v-if="usagePlan === 'BESTIE'">
        <div class="card aligner-wrapper">
          <div class="card-body">
            <div class="absolute left top bottom h-100 v-strock-2 bg-danger"></div>
            <p class="text-muted mb-2">Manage subscription</p>
            <div class="d-xl-flex align-items-center mb-2">
              <b-button class="btn-lg btn-danger btn-icon-text" v-on:click="getStripePortal"><i class="mdi mdi-credit-card btn-icon-prepend"></i>Stripe Portal</b-button>
            </div>
            <div class="d-flex align-items-center">
              <div class="bg-danger dot-indicator"></div>
              <p class="text-muted mb-0 ml-2">Continue to stripe portal</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 d-flex align-items-stretch grid-margin">
        <div class="row flex-grow">
          <div class="col-12 grid-margin">
            <div class="card" v-if="user">
              <p v-if="user.attributes && user.attributes.identities" class="subtitle-2 pa-10 text-center my-5">Looks like you've got a social login like Google, Amazon or Facebook, you'll need to updated your details through those services.</p>
              <div class="card-body" v-if="user.attributes && !user.attributes.identities">
                
                <h4 class="card-title">Change Password</h4>
                <p class="card-description">
                  Update your password below
                </p>
                <form class="forms-sample">
                  <b-form-group label="Current Password"  label-for="inputOld">
                    <b-form-input type="password" id="oldPassword" placeholder="Password"
                      v-model='$v.form.oldPassword.$model'
                      :error-messages="error"
                      @input="$v.form.oldPassword.$touch()"
                      @blur="$v.form.oldPassword.$touch()"
                      :state="$v.form.oldPassword.$dirty ? !$v.form.oldPassword.$error : null"
                      aria-describedby="oldPassword-feedback"
                      required
                      outlined
                    
                    ></b-form-input>
                    <b-form-invalid-feedback id="oldPassword-feedback">
                      {{ oldErrors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group label="New Password"  label-for="inputNew">
                    <b-form-input type="password" id="newPassword" placeholder="Password"
                      v-model='$v.form.newPassword.$model'
                      :error-messages="error"
                      @input="$v.form.newPassword.$touch()"
                      @blur="$v.form.newPassword.$touch()"
                      :state="$v.form.newPassword.$dirty ? !$v.form.newPassword.$error : null"
                      aria-describedby="newPassword-feedback"
                      required
                      outlined
                    ></b-form-input>
                    <b-form-invalid-feedback id="newPassword-feedback">
                      {{ newErrors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <div class="d-flex">
                    <b-button type="button" variant="success" class="mr-2" v-on:click="submit">Submit</b-button>
                    <b-button variant="dark" v-on:click="clear">Cancel</b-button>
                  </div>
                  <div class="row mt-3">
                    <div class="col-3">
                      <p v-if="submitStatus === 'OK'" class="text-success">Password reset!</p>
                      <p v-if="submitStatus === 'ERROR'" class="text-danger">Error updating password!</p>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script lang="js">
import { Auth } from 'aws-amplify'
import { validationMixin } from 'vuelidate'
import { required, minLength } from 'vuelidate/lib/validators'

function getUser() {
  return Auth.currentAuthenticatedUser().then((data) => {
  if (data && data.signInUserSession) {
    return data;
  } 
  }).catch((e) => {
    //console.log(e)
    return null
  });
}

export default {
  name: 'account',
  mixins: [validationMixin],
  validations: {
    form: {
      oldPassword: { required },
      newPassword: {
        required,
        minLength: minLength(8),
        containsUppercase: function(value) {
          return /[A-Z]/.test(value)
        },
        containsLowercase: function(value) {
          return /[a-z]/.test(value)
        },
        containsNumber: function(value) {
          return /[0-9]/.test(value)
        },
        containsSpecial: function(value) {
          return /[#?!@$%^&*-]/.test(value)
        }
      }
    }
  },
  data() {
    return {
      loadingType: true,
      loadingAcc: true,
      show1: false,
      show2: false,
      error: { message: null },
      form: {
        oldPassword: '',
        newPassword: ''
      },
      password: 'Password',
      submitStatus: null,
      usagePlan: null,
      stripeError: null,
      user: null,
      signLinks: [
        { icon: '', text: 'Dashboard', link: '/dashboard' },
        { icon: '', text: 'Usage', link: '/usage' },
        { icon: '', text: 'Account', link: '/account' },
        { icon: '', text: 'Upgrade', link: '/upgrade' }
      ]
    }
  },
  computed: {
    oldErrors () {
      const errors = []
      if (!this.$v.form.oldPassword.$dirty) return errors
        //!this.$v.oldPass.maxLength && errors.push('Name must be at most 10 characters long')
        !this.$v.form.oldPassword.required && errors.push('Required!')
      return errors
    },
    newErrors () {
      const errors = []
      if (!this.$v.form.newPassword.$dirty) return errors
        //!this.$v.newPass.email && errors.push('Must be valid e-mail')
        !this.$v.form.newPassword.minLength && errors.push('Must be at least 8 characters')
        !this.$v.form.newPassword.containsUppercase && errors.push('Must contain uppercase')
        !this.$v.form.newPassword.containsLowercase && errors.push('Must contain lowercase')
        !this.$v.form.newPassword.containsNumber && errors.push('Must contain number')
        !this.$v.form.newPassword.containsSpecial && errors.push('Must contain special chars')
        !this.$v.form.newPassword.required && errors.push('Required!')
      return errors
    }
  },

  methods: {
      submit () {
        this.$v.$touch()
        if (this.$v.form.$anyError) {
          return
        }
        this.newPassword(this.form.oldPassword, this.form.newPassword);
      },
      clear () {
        this.$v.$reset()
        this.form.newPassword = ''
        this.form.oldPassword = ''
      },
    newPassword(oldPass, newPass) {
      Auth.currentAuthenticatedUser()
        .then(user => {
            return Auth.changePassword(user, oldPass, newPass);
        })
        .then(data => 
          this.clear(),
          this.submitStatus = 'OK'
        )
        .catch(err => 
          this.submitStatus = 'ERROR'
        );
    },
    async checkUsagePlan() {
      this.user = await getUser();

      const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': this.user.signInUserSession.accessToken.jwtToken }
      };
      fetch(process.env.VUE_APP_BASE_URL + '/usageplan', requestOptions)
        .then(async response => {
          const data = await response.json();

          // check for error response
          if (!response.ok) {
            // get error message from body or default to response status
            const error = (data && data.message) || response.status;
            //this.submitStatusGA = 'ERROR'
            this.loadingType = false
            this.usagePlan = 'Error';
            return Promise.reject(error);
          }


          if (data.apiplan == "" || data.apiplan == process.env.VUE_APP_FREEID) {
            this.usagePlan = 'FREEBIE'
          } else if (data == 'error') {
            this.usagePlan = 'Error';
          }
          else {
            this.usagePlan = 'BESTIE'
          }

          this.loadingType = false
          
        })
        .catch(error => {
          this.loadingType = false
          this.usagePlan = 'Error';
        });
    },
    async getStripePortal() {
      this.user = await getUser();

      const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': this.user.signInUserSession.accessToken.jwtToken }
      };
      fetch(process.env.VUE_APP_BASE_URL + '/portal', requestOptions)
        .then(async response => {
          const data = await response.json();

          // check for error response
          if (!response.ok) {
            // get error message from body or default to response status
            const error = (data && data.message) || response.status;
            this.stripeError = 'error validating stripe account'
            return Promise.reject(error);
          }

          if (data.urlSession) {
            let urlSession = data.urlSession
            window.location.href = urlSession
            //window.open(urlSession, '_blank')
          }

          
        })
        .catch(error => {
          this.stripeError = 'error validating stripe account'
        });
    },
    async checkSession(session) {
    this.user = await getUser();
    // POST request using fetch with error handling
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': this.user.signInUserSession.accessToken.jwtToken },
      body: JSON.stringify({ session_id: session })
    };
    fetch(process.env.VUE_APP_BASE_URL + '/session', requestOptions)
      .then(async response => {
        const data = await response.json();

        // check for error response
        if (!response.ok) {
          // get error message from body or default to response status
          const error = (data && data.message) || response.status;
          this.submitStatus = 'ERROR'
          return Promise.reject(error);
        }

        //console.log(data)

      })
      .catch(error => {
        this.errorMessage = error;
        //console.error('There was an error!', error);
        this.submitStatus = 'ERROR'
      });
    },
  },
  async beforeCreate() {
    let user = await getUser();
    this.user = user;
    this.loadingAcc = false;
    let plan = await this.checkUsagePlan();
    this.usagePlan = plan;
  },
  created() {
    // For the stripe return
    if (this.$route.query.session_id) {
      this.checkSession(this.$route.query.session_id)
    }
  },
  filters: {
    splitEmail: function(email) {
      let split = email.split('@')
          split = split[0]
      return split
    },
  },
}
</script>